import { Controller } from "stimulus";

const REFRESH_MARGIN_MS = 5 * 60 * 1000;
const REAUTH_PARAM = "reauth";
const ONE_TIME_PARAMS = ["new_training", "product_tour", "show_file_upload"];

export default class extends Controller {
  static targets = ["banner"];

  static values = {
    expiresIn: Number
  };

  connect() {
    this.clearReauthParam();
    if (!this.expiresInValue) return;

    this.refreshAt = Date.now() + this.expiresInValue * 1000 - REFRESH_MARGIN_MS;
    this.reloading = false;
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    this.timer = window.setTimeout(() => this.handleRefreshDue(), Math.max(this.refreshAt - Date.now(), 0));
  }

  disconnect() {
    if (this.handleVisibilityChange) {
      document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    }
    window.clearTimeout(this.timer);
  }

  handleVisibilityChange() {
    if (document.visibilityState === "visible" && this.refreshDue()) {
      this.reload();
    }
  }

  handleRefreshDue() {
    if (document.visibilityState === "visible" && this.hasBannerTarget) {
      this.bannerTarget.classList.remove("d-none");
      this.bannerTarget.classList.add("d-flex");
    }
  }

  refreshDue() {
    return Date.now() >= this.refreshAt;
  }

  reload() {
    if (this.reloading) return;

    this.reloading = true;
    const url = new URL(window.location.href);
    ONE_TIME_PARAMS.forEach((param) => url.searchParams.delete(param));
    url.searchParams.set(REAUTH_PARAM, "1");
    window.location.replace(url.toString());
  }

  clearReauthParam() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has(REAUTH_PARAM)) return;

    url.searchParams.delete(REAUTH_PARAM);
    window.history.replaceState(window.history.state, "", url.toString());
  }
}
